// --- Bug fix from Audit (Mike): Dawn theme shows no cart icon update after initial ATC. 
    // Only needed if cart is empty - runs only once for the "empty" to ">0 pieces" transition. Bugfix Mike. ---
(function() {
  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
  const count = bubble ? parseInt(bubble.textContent.trim(), 10) : 0;
  var hasUpdatedCartIcon = false;
  
  if (count > 0) return; // cart already has items — do nothing
  // --- start refresh logic ---
  function updateHeaderCartIcon(itemCount) {
    const el = document.querySelector('#cart-icon-bubble');
    if (!el) return;

    // Rebuild markup
    const count = Number(itemCount) || 0;
    const svgFilled = `<svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg>`;
    const svgEmpty = `<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"></path></svg>`;

    const html = count > 0
      ? `${svgFilled}<span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${count}</span><span class="visually-hidden">${count}</span></div>`
      : `${svgEmpty}<span class="visually-hidden">Cart</span>`;

    el.innerHTML = html;
  }

  function refreshCartUI() {
    if (hasUpdatedCartIcon) return; // exit if already updated once
    hasUpdatedCartIcon = true;
    console.log("UPDATING CART ICON TO >0");
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        updateHeaderCartIcon(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      })
      .catch(console.error);
  }

  // Intercept fetch() calls so that when UpCart adds the first item, we'll update
  const originalFetch = window.fetch;
  window.fetch = function(resource, init) {
    return originalFetch(resource, init).then(response => {
      try {
        const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        if (url.includes('/cart/add') || url.includes('/cart/add.js')) {
          setTimeout(refreshCartUI, 250);
        }
      } catch (e) {}
      return response;
    });
  };

  // Optional / mike: initial sync on load if something alrdy queued
 // window.addEventListener('load', () => setTimeout(refreshCartUI, 100));
  // --- end refresh logic ---
})();